var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"8","cy":"8","r":"7.5","fill":"white","stroke":"#9AA5B0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }